// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Label from '../../../components/Label';
import SvgIconStyle, { SvgIconStyleType } from '../../../components/SvgIconStyle';
import SeloAvisos from './SeloAvisos';
// ----------------------------------------------------------------------

export interface GetIconType {
  name: string;
}

export interface ItemConfigNav {
  title: string;
  path: string;
  icon?: any;
  info?: any;
  children?: Array<ItemConfigNav>;
}

export interface ConfigNav {
  subheader: string;
  items: Array<ItemConfigNav>;
}

const getIcon = (name: string) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;
const getIconGPS = (name: string) => <SvgIconStyle src={`${name}`} sx={{ width: 1, height: 1 }} />;

export const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_home'),
  aplicativos: getIcon('ic_aplicativos'),
  comunicacao: getIcon('ic_comunicacao'),
  evento: getIcon('ic_evento'),
  noticia: getIcon('ic_noticia'),
  configuracao: getIcon('ic_configuracao'),
  consumer: getIcon('ic_consumer'),
  map: getIcon('ic_map'),
  track: getIcon('ic_track'),
  dispositivos: getIcon('ic_dispositivos'),
  transferencias: getIcon('ic_transferencias'),
  novidades: getIcon('ic_noticia'),
  manual: getIcon('ic_blog'),
  group: getIcon('ic_group'),
  android: getIcon('ic_android'),
  users: getIcon('ic_users'),
  chaves: getIcon('ic_chaves'),
  devices: getIcon('ic_devices'),
  politica: getIcon('ic_politica'),
  apks: getIcon('ic_apks'),
};


// ----------------------------------------------------------------------
// O menu aponta para as telas do VISUAL NOVO (sufixo `-novo` nas rotas).
//
// As telas antigas continuam publicadas e acessiveis por URL direta - elas
// hospedam os formularios de criar/editar, que ainda nao foram migrados. Voltar
// atras e trocar `xNovo` por `x` nestas linhas; nenhum arquivo precisa ser
// restaurado.
//
// "Buscar" e "Configurar" (dispositivos) e "Acessos" (regionais) seguem nas
// telas antigas de proposito: sao fluxos de escrita em dispositivo real, e a
// migracao deles nao e troca de estilo, e reescrita com risco em campo.
// ----------------------------------------------------------------------
export const navConfigAdminPlus: ConfigNav[] = [
  {
    subheader: 'geral',
    items: [
      { title: 'Home', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      { title: 'Aplicativos', path: PATH_DASHBOARD.general.aplicativosNovo, icon: ICONS.aplicativos },
      { title: 'Grupos', path: PATH_DASHBOARD.general.entidadesNovo, icon: ICONS.devices },
      { title: 'Politicas', path: PATH_DASHBOARD.general.politicasNovo, icon: ICONS.politica },
      {
        title: 'Dispositivos',
        path: PATH_DASHBOARD.general.dispositivosNovo,
        icon: ICONS.dispositivos,
        children: [
          { title: 'Listar', path: PATH_DASHBOARD.general.dispositivosNovo },
          { title: 'Buscar', path: PATH_DASHBOARD.general.busca },
          { title: 'Configurar', path: PATH_DASHBOARD.general.dispositivosConfigurar },
        ],
      },
      { title: 'Transferencias', path: PATH_DASHBOARD.general.transferencias, icon: ICONS.transferencias },
      { title: 'APKS', path: PATH_DASHBOARD.general.apksNovo, icon: ICONS.apks },
      {
        title: 'Avisos',
        path: PATH_DASHBOARD.general.avisos,
        icon: ICONS.noticia,
        /* O selo busca o proprio numero - `NavConfig` e array estatico, avaliado
           uma vez na importacao, e um contador aqui nasceria congelado. */
        info: <SeloAvisos />,
      },
    ],
  },
  {
    subheader: 'configuração',
    items: [
      {
        title: 'Regionais',
        path: PATH_DASHBOARD.general.regionaisNovo,
        icon: ICONS.kanban,
        children: [
          { title: 'Listar', path: PATH_DASHBOARD.general.regionaisNovo },
          { title: 'Acessos', path: PATH_DASHBOARD.general.regionaisAcessos },
        ],
      },
      { title: 'Usuários', path: PATH_DASHBOARD.general.usersNovo, icon: ICONS.users },
      { title: 'Chave de Acesso', path: PATH_DASHBOARD.general.chave_acesso, icon: ICONS.chaves },
      /* LOGS DO SISTEMA: so no menu do Master (11/09/2026, a pedido).

         Este arquivo tem tres menus - AdminPlus (Master), Admin e Cliente - e o
         item entra APENAS neste. Esconder do menu nao e a protecao: a rota
         `/logs/sistema` recusa quem nao e Master no servidor, e a pagina
         tambem confere. O menu so evita que alguem esbarre numa tela que nao
         vai conseguir usar. */
      { title: 'Logs do sistema', path: PATH_DASHBOARD.general.logs, icon: ICONS.analytics },
      // Monitoramento (servidor e banco): mesma regra dos logs - so Master, e as rotas recusam no servidor.
      { title: 'Monitoramento', path: PATH_DASHBOARD.general.monitoramento, icon: ICONS.analytics },
    ],
  },
  {
    // Suporte (tickets), Documentos (manual) e Novidades sairam do menu lateral e
    // ficam no RODAPE (src/layouts/dashboard/RodapeDashboard.tsx): sao telas de
    // apoio, e no menu competiam por espaco com os modulos de trabalho.
    //
    // Aqui fica somente a CONFIGURACAO de ticket, que e exclusiva do MASTER
    // (este arquivo e navConfigAdminPlus, escolhido em NavbarVertical.jsx:77).
    // O backend tambem valida - esconder aqui e conveniencia, nao protecao.
    subheader: 'configuração de suporte',
    items: [
      {
        title: 'Tickets',
        path: PATH_DASHBOARD.general.ticketsCategorias,
        icon: ICONS.mail,
        children: [
          { title: 'Categorias e SLA', path: PATH_DASHBOARD.general.ticketsCategorias },
          { title: 'Feriados', path: PATH_DASHBOARD.general.ticketsFeriados },
        ],
      },
    ],
  },
];

export const navConfigAdmin: ConfigNav[] = [
  {
    subheader: 'geral',
    items: [
      { title: 'Home', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      { title: 'Aplicativos', path: PATH_DASHBOARD.general.aplicativosNovo, icon: ICONS.aplicativos },
      { title: 'Grupos', path: PATH_DASHBOARD.general.entidadesNovo, icon: ICONS.devices },
      { title: 'Politicas', path: PATH_DASHBOARD.general.politicasNovo, icon: ICONS.politica },
      {
        title: 'Dispositivos',
        path: PATH_DASHBOARD.general.dispositivosNovo,
        icon: ICONS.dispositivos,
        children: [
          { title: 'Listar', path: PATH_DASHBOARD.general.dispositivosNovo },
          { title: 'Buscar', path: PATH_DASHBOARD.general.busca },
          // Configurar restrito a usuarios com flag Desenvolvedor - so aparece em navConfigAdminPlus.
        ],
      },
      { title: 'Transferencias', path: PATH_DASHBOARD.general.transferencias, icon: ICONS.transferencias },
      { title: 'APKS', path: PATH_DASHBOARD.general.apksNovo, icon: ICONS.apks },
      {
        title: 'Avisos',
        path: PATH_DASHBOARD.general.avisos,
        icon: ICONS.noticia,
        /* O selo busca o proprio numero - `NavConfig` e array estatico, avaliado
           uma vez na importacao, e um contador aqui nasceria congelado. */
        info: <SeloAvisos />,
      },
    ],
  },
  {
    subheader: 'configuração',
    items: [
      {
        title: 'Regionais',
        path: PATH_DASHBOARD.general.regionaisNovo,
        icon: ICONS.kanban,
        children: [
          { title: 'Listar', path: PATH_DASHBOARD.general.regionaisNovo },
          { title: 'Acessos', path: PATH_DASHBOARD.general.regionaisAcessos },
        ],
      },
      { title: 'Usuários', path: PATH_DASHBOARD.general.usersNovo, icon: ICONS.users },
      { title: 'Chave de Acesso', path: PATH_DASHBOARD.general.chave_acesso, icon: ICONS.chaves },
    ],
  },
];

export const navConfigCliente: ConfigNav[] = [
  {
    subheader: 'geral',
    items: [
      { title: 'Home', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      { title: 'Grupos', path: PATH_DASHBOARD.general.entidadesNovo, icon: ICONS.devices },
      {
        title: 'Avisos',
        path: PATH_DASHBOARD.general.avisos,
        icon: ICONS.noticia,
        /* O selo busca o proprio numero - `NavConfig` e array estatico, avaliado
           uma vez na importacao, e um contador aqui nasceria congelado. */
        info: <SeloAvisos />,
      },
    ],
  },
  {
    subheader: 'configuração',
    items: [
      { title: 'Chave de Acesso', path: PATH_DASHBOARD.general.chave_acesso, icon: ICONS.chaves },
    ],
  },
];
